export const SUPPLEMENTS_MATCH_PARAMS = {
  CAMBIO_DATOS_BASICOS: "CAMBIO-DATOS-BASICOS",
};

export const SEND_TO = {
  BACKOFFICE: {
    backOffice: true,
    sendaApi: false,
  },
  SENDA_API: {
    backOffice: false,
    sendaApi: true,
  },
};

export const PERSONA_TYPE = {
  TOMADOR: "TOMADOR",
  ASEGURADO: "ASEGURADO",
  MASCOTA: "MASCOTA",
};

export const MASCOTA_TYPE: { [key: string]: string } = {
  CANINE: "01",
  FELINE: "02",
};

